import { render, staticRenderFns } from "./section-create-password.vue?vue&type=template&id=20404adf&scoped=true&"
import script from "./section-create-password.vue?vue&type=script&lang=js&"
export * from "./section-create-password.vue?vue&type=script&lang=js&"
import style0 from "./section-create-password.vue?vue&type=style&index=0&id=20404adf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20404adf",
  null
  
)

export default component.exports